import { addMonths } from 'date-fns';
import { formatIncaDate } from '../../utils/date.ts';

export const getStralbehandlingMaxStartDate = () => {
    return formatIncaDate(addMonths(new Date(), 1));
};
